module.exports = __webpack_public_path__ + "static/media/unstakeLight.52ac7917.svg";